import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "week",
  // Collapsed group row shows the selected measure: inventory first, WOS on
  // expand — segment by SKU alone so hub + in-transit + spoke sum together.
  measure: "Inventory",
  segments: ["sku"],
  minDate: dayjs.utc().startOf("year").toDate(),
  maxDate: dayjs.utc().add(1, "year").startOf("year").toDate(),
  filters: [],
  postFilters: [],
};
